"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumChangeProfileType = void 0;
exports.EnumChangeProfileType = {
    Other: 'Other',
    Self: 'Self',
    Unknown: 'Unknown',
};
//# sourceMappingURL=enum-change-profile-type.js.map